export default {
  refreshYourResults: 'Vernieuw je resultaten',
  weNeedTo: 'Voor de meest recente prijzen en beschikbaarheid moeten we',
  refreshResults: 'je resultaten vernieuwen.',
  okRefresh: 'Oké, vernieuwen',
}
